<template>
  <div>
    <b-row v-if="locationLoading">
      <div class="text-center w-100">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-form-group
          :label="$lang.interview_location_plan_place"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.interview_location_plan_place"
            :rules="$v.location_selected.$params"
          />
          <selectFind
            :options="location_options"
            v-model="$v.location_selected.$model"
            label="caption"
            :isValid="
              $v.location_selected.$dirty ? !$v.location_selected.$error : null
            "
            :loading="locationLoading"
            :placeholder="$lang.search_city"
          />

          <b-form-invalid-feedback
            :style="{ display: $v.location_selected.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required
                | replace($lang.interview_location_plan_place)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.interview_location_plan_interview_date"
          label-for="interview_date"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.interview_location_plan_interview_date"
            :rules="$v.interview_date.$params"
          />
          <date-picker
            v-model="$v.interview_date.$model"
            format="YYYY-MM-DD "
            display-format="dddd jDD jMMMM jYYYY "
            inputReq="true"
            :state="$v.interview_date.$dirty ? !$v.interview_date.$error : null"
            :class="
              $v.interview_date.$dirty
                ? $v.interview_date.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :style="{ display: $v.interview_date.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required
                | replace($lang.interview_location_plan_interview_date)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="
            $lang.interview_location_plan_room_number + ' ' + $lang.room_num
          "
          label-for="room_number"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="
              $lang.interview_location_plan_room_number + ' ' + $lang.room_num
            "
            :rules="$v.room_number_selected.$params"
          />
          <selectFind
            :options="room_number_options"
            v-model="$v.room_number_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.room_number_selected.$dirty
                ? !$v.room_number_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.room_number_selected.$error ? 'block' : 'none',
            }"
            id="room_number_selected_feedback"
          >
            {{
              $lang.error_required
                | replace(
                  $lang.interview_location_plan_room_number +
                    " " +
                    $lang.room_num
                )
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" class="float-right">
        <div slot="footer" class="form-group form-btn">
          <b-button @click="submit" type="submit" size="md" variant="success">
            <i class="fa fa-check"></i>
            {{ $lang.submitButton }}
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancel"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import { required } from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  validations: {
    location_selected: {
      required,
    },
    interview_date: {
      required,
    },
    room_number_selected: {
      required,
    },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: "",
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      location_options: [],
      locationLoading: false,
      location_selected: null,
      interview_date: null,
      room_number_selected: null,
      room_number_options: [],
    };
  },
  methods: {
    async getLocation() {
      try {
        this.locationLoading = true;
        let url =
          this.$config.api_url +
          this.$config.interview.interview_location_combo;
        const response = await this.$httpService.get(url);
        let locations = response.data.data.map((x) => {
          return {
            id: x.id,
            caption:
              `(شماره مکان${x.id}) ` +
              x.place_caption +
              `${x.full_path ? `( ${x.full_path} )` : ``}`,
            room: x.room,
          };
        });
        this.location_options = locations;
      } catch (error) {
        this.$generateError(error);
        this.location_options = [];
      } finally {
        this.locationLoading = false;
      }
    },
    cancel() {
      this.$emit("cancel", false);
      this.$emit("closeModal", false);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      let payload = {
        interview_location_id: pathOr(null, ["id"], this.location_selected),
        interview_date: this.interview_date || null,
        room_number: pathOr(null, ["value"], this.room_number_selected),

        audience_context_grade_id: null,
        audience_license_type_id: null,
        interview_count: null,
        interview_grade: [],
        count: null,
        interview_grade_id: null,
        room_audience_count: null,
      };

      this.$emit("submit", payload);
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        this.getLocation().then(() => {
          if (this.item.location)
            this.location_selected = this.location_options.find(
              (x) => x.id == this.item.interview_location_id
            );
          let room = this.location_selected.room.find(
            (x) => x.room_number == this.item.room_number.toString()
          );
          if (room) {
            this.room_number_selected = {
              value: room.room_number,
              text:
                room.room_number +
                `${room.room_name ? `( ${room.room_name} )` : ``}`,
            };
          }
        });

        this.interview_date =
          this.item.interview_date && this.item.interview_date.gregorian;
      } else {
        await this.getLocation();
      }
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    location_selected(newValue) {
      this.room_number_options =
        newValue &&
        newValue.room.map((x) => {
          return {
            value: x.room_number,
            text:
              x.room_number + `  ${x.room_name ? `( ${x.room_name} )` : ""} `,
          };
        });
    },
  },
};
</script>

<style>
.room_plan > .col > .multiselect__valid > .multiselect__tags {
  font-size: 9px !important;
  min-height: 36px;
}

.room_plan > .col > .multiselect {
  min-height: 36px;
}

.room_plan > .col > .multiselect > .multiselect__tags {
  min-height: 36px;
  font-size: 9px !important;
}

.hw-10 {
  width: 34%;
}
</style>
